import {isLocal} from './debug';
export default function emitGuestPickerEvent(options = {}) {
    // Debug message
    /* istanbul ignore next */
    if (isLocal()) {
        console.log('raise generic edap event - ', options); //eslint-disable-line
    }

    // If edap does not exist, define array so overloaded push() method can raise event
    window.edap = window.edap || [];
    window.edap.push((edap) => {
        edap.trigger('generic.event', options);
    });
}
